import script from "./PasswordDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./PasswordDialog.vue?vue&type=script&lang=ts&setup=true"

import "./PasswordDialog.vue?vue&type=style&index=0&id=2550bfeb&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2550bfeb"]])

export default __exports__